import { getAttribution } from './attributionStore';

export type CheckoutAttributionHeaders = Partial<
  Record<'x-gclid' | 'x-gbraid' | 'x-wbraid' | 'x-gclid-clicked-at', string>
>;

export const getCheckoutAttributionHeaders = (): CheckoutAttributionHeaders => {
  const attribution = getAttribution();
  if (!attribution) return {};

  const clickId: readonly ['x-gclid' | 'x-gbraid' | 'x-wbraid', string] | null =
    attribution.gclid
      ? ['x-gclid', attribution.gclid]
      : attribution.gbraid
        ? ['x-gbraid', attribution.gbraid]
        : attribution.wbraid
          ? ['x-wbraid', attribution.wbraid]
          : null;

  if (!clickId) return {};

  const [headerName, headerValue] = clickId;
  return {
    [headerName]: headerValue,
    'x-gclid-clicked-at': new Date(attribution.capturedAt).toISOString(),
  };
};
